import { generateHeader, POSTAPI } from "src/api-setup/api-helper";
import { GET_ALL_TASK_CATEGORY } from "src/api-setup/api-endpoints";

export const getAllPayRequestType = async (cookiesData, dispatch, providerId, scope = {}) => {
  if (!cookiesData) return [];

  try {
    const apiHeaders = generateHeader();
    const requestBody = {
      in_tenant_id: cookiesData.out_tenant_id,
      ...(providerId ? { in_provider_mstr_key: providerId } : { in_user_id: cookiesData.out_user_id }),
      in_sort_number: 1,
      in_sort_order: "ASC",
      ...scope,
    };

    const response = await POSTAPI(false, GET_ALL_TASK_CATEGORY, null, apiHeaders, requestBody, dispatch);

    return response;
  } catch (error) {
    console.error("Error fetching all pay request type:", error);
    return [];
  }
};
